import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import * as qs from 'querystringify';
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { DriveApiError } from "../common/error";
import { requestV1Cgi, RetCode } from "../data-source/network-request";

/**
 * 移动文件
 */
export function moveFile(params) {
  return new MoveFileRequest(params).send();
}

/**
 * 移动文件夹
 */
export function moveFolder(params) {
  return new MoveFolderRequest(params).send();
}
/**
 * 移动文件
 */
export var MoveFileRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(MoveFileRequest, _DriveRequest);
  var _super = _createSuper(MoveFileRequest);
  function MoveFileRequest() {
    _classCallCheck(this, MoveFileRequest);
    return _super.apply(this, arguments);
  }
  _createClass(MoveFileRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/doc_move',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          domain_id: DEFAULT_DOMAIN_ID,
          pad_id: params.id,
          target_folder_id: params.folderId,
          xsrf: getXsrfToken()
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'MoveFileResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return MoveFileRequest;
}(DriveRequest);

/**
 * 移动文件夹
 */
export var MoveFolderRequest = /*#__PURE__*/function (_DriveRequest2) {
  _inherits(MoveFolderRequest, _DriveRequest2);
  var _super2 = _createSuper(MoveFolderRequest);
  function MoveFolderRequest() {
    _classCallCheck(this, MoveFolderRequest);
    return _super2.apply(this, arguments);
  }
  _createClass(MoveFolderRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/cgi-bin/online_docs/folder_move',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: qs.stringify({
          folder_id: params.id,
          parent_folder_id: params.folderId,
          is_auto_rename: 1,
          xsrf: getXsrfToken()
        })
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      if (response.retcode !== RetCode.Success) {
        throw new DriveApiError({
          name: 'MoveFolderResultError',
          message: response.msg,
          params: this.params,
          payload: this.payload,
          response: response
        });
      }
    }
  }]);
  return MoveFolderRequest;
}(DriveRequest);
var DEFAULT_DOMAIN_ID = '300000000';
//# sourceMappingURL=move.js.map